/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   setMapViewportFromBounds
 */

import { isValidBounds } from '@zcode/nr-utils'
import type { AutocompleteBoxType, GetState } from '@zcode/state-type'
import WebMercatorViewport from 'viewport-mercator-project'

import type { Dispatch } from '../../types'
import { show } from '../actions'
import { selectMapDimensions } from '../selectors'

import { updateViewState } from './updateViewState'

const VIEWPORT_PADDING = 80

export const setMapViewportFromBounds =
  ({ bounds }: { bounds: AutocompleteBoxType }) =>
  (dispatch: Dispatch, getState: GetState) => {
    if (isValidBounds(bounds)) {
      const { minLat, maxLat, minLng, maxLng } = bounds

      const state = getState()
      const dimensions = selectMapDimensions(state) as any

      const viewport = new WebMercatorViewport(dimensions).fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat],
        ],
        { padding: VIEWPORT_PADDING }
      )
      dispatch(updateViewState(viewport))
      setTimeout(() => {
        dispatch(show())
      }, 250)
    }
  }
